import React, { useState } from 'react'
import { Tab, Row, Nav } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useRouteMatch, Route, Switch } from 'react-router-dom'
import {
  getUserModuleActions,
  getUserSubModuleActions,
} from '../../../../store/user/selectors'
import { checkPermission } from '../../../../utils/utilFunctions'
import PiFileView from '../../../compensationRecommendation/compensation/pi/PiFileView'
import PiApplication from './PiApplication'
import PiFileRegistration from './PiFileRegistration'
import PiReturn from './PiReturn'

const Pi = () => {
  const { path } = useRouteMatch()
  const [selectedSection, setSelectedSection] = useState('pi')

  const actionListModule = useSelector(
    getUserModuleActions('application-registration', 'compensation', 'pi')
  )

  const actionListSubModule = useSelector(
    getUserSubModuleActions(
      'application-registration',
      'compensation',
      'pi',
      'file-return'
    )
  )
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container id="left-tabs-example" defaultActiveKey="pi">
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              {checkPermission('view', actionListModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('pi')
                    }}
                    eventKey="pi"
                  >
                    PI Application
                  </Nav.Link>
                </Nav.Item>
              )}
              {checkPermission('view', actionListSubModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('pi-return')
                    }}
                    eventKey="pi-return"
                  >
                    PI Return
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </Row>
          <Row className="page-tiles-layout align-content-start">
            {selectedSection === 'pi' ? (
              <>
                {checkPermission('view', actionListModule) && <PiApplication />}
              </>
            ) : (
              <>
                {checkPermission('view', actionListSubModule) && <PiReturn />}
              </>
            )}
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/view/:id`}
        render={(props) => <PiFileRegistration type="file" {...props} />}
      />
      <Route
        path={`${path}/return/:id`}
        render={(props) => <PiFileRegistration type="return" {...props} />}
      />
      <Route
        path={`${path}/view-similar/:id`}
        render={(props) => <PiFileView type="similar" {...props} />}
      />
    </Switch>
  )
}

export default Pi
